export default {
  common_button_back: 'Zurück',
  common_button_cancel: 'Abbrechen',
  common_button_next: 'Weiter',
  common_button_no: 'Nein',
  common_button_ok: 'OK',
  common_button_reset: 'Zurücksetzen',
  common_button_skip: 'Überspringen',
  common_button_yes: 'Ja',
  common_deactivated_message:
    'Dieser Kiosk ist derzeit in einem anderen Gerät im Einsatz. Bitte erneut einloggen. Danke!',
  common_deactivated_title: 'Der Kiosk ist auf diesem Gerät deaktiviert.',
  common_enterEmail_email: 'Bitte geben Sie Ihre Geschäfts-E-Mail-Adresse ein',
  common_enterEmail_title: 'Ihre E-Mail-Adresse',
  common_error_message_cameraNotAllowed:
    'Der Zugriff auf die Kamera ist benötigt um diese Funktion anwenden zu können.',
  common_error_message_ForbiddenException:
    'Es scheint, dass Sie nicht genügend Befugnisse haben, um diese Aktion durchzuführen.',
  common_error_message_incorrectEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  common_error_message_invalidCredentials: 'Hoppla! Name und/oder Passwort falsch. Bitte versuchen Sie es erneut.',
  common_error_message_invalidMobile: 'Bitte geben Sie eine gültige Mobiltelefonnummer ein.',
  common_error_message_missingField: 'Pflichtfeld',
  common_error_message_noInternetConnection:
    'Die Internetverbindung wurde unterbrochen. Bitte versuchen Sie es erneut.',
  common_error_message_unauthorizedAccess: 'Unbefugter Zugang',
  common_error_message_webServiceWrongConnection:
    'Fehler: Datenübertragung unterbrochen. Bitte versuchen Sie es erneut.',
  common_error_title: 'Fehler',
  common_expired_message:
    'Ihre Testversion ist abgelaufen oder Ihre Kreditkarte funktioniert nicht mehr. Bitte aktualisieren Sie Ihre Rechnungsdaten, um das Konto wieder zu aktivieren. Bei Fragen wenden Sie sich an sales@proxyclick.com. Danke!',
  common_expired_title: 'Konto abgelaufen',
  common_onboarding_login_button: 'Login',
  common_onboarding_message1: 'Proxyclick hilft Ihnen Ihre Besuchenden genau so zu empfangen, wie Sie es wünschen.',
  common_onboarding_message2:
    'Gestalten Sie den Kiosk sowie die Ausweise auf Basis Ihres Markenprofils und hinterlassen Sie einen guten ersten Eindruck.',
  common_onboarding_message3:
    'Gastgebende werden benachrichtigt sobald ihre Besuchenden ankommen und können sofort antworten.',
  common_onboarding_message4:
    'Verbessern Sie die Sicherheit Ihrer Räumlichkeiten und stellen Sie sicher, dass alle Schutzmaßnahmen eingehalten werden: Notfallliste, unterzeichnete Vereinbarungen, usw.',
  common_onboarding_message5:
    'Proxyclick übernimmt die harte Arbeit, damit Sie Ihre Besuchenden mit einem Lächeln begrüßen können.',
  common_placeholder_optional: 'Optional',
  common_setup_activationCode_activate_button: 'Aktivieren',
  common_setup_activationCode_code: 'Geben Sie Ihren Aktivierungscode ein',
  common_setup_activationCode_code_placeholder: 'z.B. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Ungültiger Freischaltcode',
  common_setup_activationCode_footer:
    'Der Aktivierungscode kann für SSO-Administrierende oder lokale Sicherheitskräfte nützlich sein. Erfahren Sie mehr.',
  common_setup_activationCode_title: 'Kiosk per Freischaltcode aktivieren',
  common_setup_device_footer: 'Um einen neuen Kiosk zu erstellen, loggen Sie sich im Dashboard ein.',
  common_setup_device_locked_content:
    'Dieser Kiosk wurde bereits auf einem anderen Gerät aktiviert, welcher somit deaktiviert wird. Sind Sie sich sicher, dass Sie den Kiosk auf diesem Gerät einrichten wollen?',
  common_setup_device_locked_continue_button: 'Diesen Kiosk einrichten',
  common_setup_device_locked_title: 'Kiosk bereits in Gebrauch.',
  common_setup_device_multiTenants: 'Multi-Unternehmen',
  common_setup_device_title: 'Wählen Sie Ihren Kiosk aus',
  common_setup_loading_footer: 'Um Ihren Kiosk individuell anzupassen, verbinden Sie sich mit dem Dashboard.',
  common_setup_loading_message: 'Konfigurieren...',
  common_setup_loading_title: 'Ihr Kiosk wird eingerichtet...',
  common_setup_location_footer:
    'Um einen neuen Standort zu erstellen, verbinden Sie sich mit dem Proxyclick Dashboard.',
  common_setup_location_kiosk: 'Kiosk',
  common_setup_location_kiosks: 'Kioske',
  common_setup_location_title: 'Wählen Sie Ihren Standort',
  common_setup_login_activationCode_button: 'Aktivierung per Freischaltcode?',
  common_setup_login_email: 'E-Mail',
  common_setup_login_forgotPassword_button: 'Passwort vergessen?',
  common_setup_login_password: 'Passwort',
  common_setup_login_title: 'Melden Sie sich mit Ihrem Proxyclick-Konto an.',
  common_setup_ready_header: 'Bereit, dieses Ipad als Ihren Kiosk für {0} einzurichten?',
  common_setup_ready_message: 'Das Konfigurieren dauert nur eine Minute und Ihr Kiosk ist startklar.',
  common_setup_ready_setup_button: 'Einrichten',
  common_setup_ready_title: 'Hallo {0}',
  common_signup_company: 'Firma',
  common_signup_email: 'E-Mail',
  common_signup_error_name: 'Bitte geben Sie Ihren Vor- und Nachnamen ein',
  common_signup_loading_message1:
    'Sie können Ihren Kiosk personalisieren, indem Sie sich im Proxyclick Dashboard einloggen. Wir haben Ihnen gerade eine E-Mail mit allen Details geschickt.',
  common_signup_loading_message2:
    'Auf der Webseite können Sie Ihren Drucker so einrichten, dass er beim Einchecken Ausweise druckt.',
  common_signup_loading_message3:
    'Sie können auch Benachrichtigungen aktivieren, die beim Einchecken an den/die Gastgebende gesendet werden.',
  common_signup_loading_message4: 'Und passen Sie Ihren Kiosk mit Ihren eigenen Farben und Ihrem Willkommensbild an',
  common_signup_loading_title: 'Einrichtung Ihres Kontos...',
  common_signup_name: 'Name',
  common_signup_name_placeholder: 'Vorname Nachname',
  common_signup_password: 'Passwort',
  common_signup_title: 'Willkommen bei Proxyclick',
  common_signup_tryFree_button: 'Übermitteln',
  common_timeout_content: 'Berühren um abzubrechen',
  common_timeout_title: 'Rückkehr zum Startbildschirm',
  common_tooltip_disable_button: 'Deaktivieren Sie alle Tipps',
  common_tooltip_gotIt_button: 'Verstanden',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} wurde benachrichtigt, dass ein Paket zugestellt wurde',

  dm_delivery_confirmation_title: 'Vielen Dank!',
  dm_delivery_confirmation_unknownRecipient: 'Eine Paket Zustellbenachrichtigung wurde an {{Company_Name}} gesendet',
  dm_delivery_recipient_name: 'Für wen ist das Paket?',

  dm_delivery_recipient_unknown_button: 'Ich weiß es nicht',
  em_multiTenant_alreadyRegistered_button:
    'Tippen Sie hier, wenn Sie als Mitarbeitende einchecken oder einen QR-Code zum Einchecken erhalten haben',
  em_multiTenant_notRegistered_button: 'Tippen Sie hier, um manuell einzuchecken.',
  vm_checkin_approval_confirmation_unregistered_message:
    'Wir können das Einchecken zu diesem Zeitpunkt nicht abschließen. Bitte kontaktieren Sie Ihre/-n Gastgebende oder wenden Sie sich an die Rezeption (wenn vorhanden).',
  vm_checkin_approval_confirmation_unregistered_title: 'Herzlich willkommen {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'Wir können das Einchecken zu diesem Zeitpunkt nicht abschließen. Bitte kontaktieren Sie Ihre/-n Gastgebende oder wenden Sie sich an die Rezeption (wenn vorhanden).',
  vm_checkin_approval_notapproved_title: 'Sehr geehrte/-r {{Visitor_FirstName}} {{Visitor_LastName}},',
  vm_checkin_confirmation_header_withoutPrint: 'Sie wurden registriert!',
  vm_checkin_confirmation_header_withPrint: 'Ihr Ausweis wird gerade gedruckt',

  vm_checkin_confirmation_message:
    'Einen Moment bitte, {{Host_FirstName}} {{Host_LastName}} wird gleich bei Ihnen sein',

  vm_checkin_confirmation_takeBackID: 'Vergessen Sie Ihren Ausweis nicht!',
  vm_checkin_confirmation_title: 'Vielen Dank!',
  vm_checkin_details_companyName: 'Unternehmen',
  vm_checkin_details_email: 'E-Mail',
  vm_checkin_details_firstname: 'Vorname',
  vm_checkin_details_lastname: 'Nachname',
  vm_checkin_details_title: 'Bitte geben Sie Ihre Informationen an.',
  vm_checkin_error_message_unableToCheckIn:
    'Ein Fehler ist beim Einchecken aufgetreten, bitte kontaktieren Sie das Empfangspersonal.',
  vm_checkin_flow_company: 'Firma',
  vm_checkin_flow_duration: 'Dauer',
  vm_checkin_flow_email: 'E-Mail',
  vm_checkin_flow_error_message_imageNotAvailable: 'Hoppla, Foto derzeit nicht verfügbar (Internetverbindungsproblem).',
  vm_checkin_flow_licensePlate: 'Kennzeichen',
  vm_checkin_flow_mobile: 'Bitte geben Sie Ihre Mobilfunknummer ein.',
  vm_checkin_flow_mobile_info:
    'Diese Daten werden verwendet, um im Notfall mit Ihnen in Kontakt zu treten, während Sie sich in der Einrichtung aufhalten.',

  vm_checkin_flow_tooltip_content:
    'Fragen Sie Ihre Besuchenden alles, was Sie wissen müssen, um deren Erlebnis zu optimieren oder um das Einchecken sicherer zu machen. Sie können den Ablauf der Fragen je nach Antwort ändern. Die Fragen, die Sie sehen, sind nur Beispiele für die Demo.',
  vm_checkin_flow_tooltip_title: 'Smarte Fragen',
  vm_checkin_host_enterFullName: 'Bitte geben Sie den vollständigen Namen Ihres/r Gastgebenden ein',
  vm_checkin_host_name: 'Wen besuchen Sie?',
  vm_checkin_host_notListed_block:
    'Wenn Sie den Namen des/der Gastgebenden nicht kennen oder ihn/sie nicht in der Liste finden, sprechen Sie bitte das Empfangspersonal an.',

  vm_checkin_host_notListed_continue: 'Nicht in der Liste',
  vm_checkin_host_tooltip_content:
    'Geben Sie hier Ihren Namen ein, und wir senden Ihnen die Benachrichtigungs-E-Mail, die Mitarbeitende erhalten, wenn ihre Besuchenden eintreffen.',
  vm_checkin_host_tooltip_title: 'Gast-Eincheck-Benachrichtigung',
  vm_checkin_host_unknown_button: 'Ich weiß es nicht',
  vm_checkin_idScan_aila_footer: 'Dieser Bildschirm wird übersprungen, wenn Sie die empfohlene Hardware benutzen ({0})',
  vm_checkin_idScan_aila_header: 'Bitte scannen Sie Ihre ID',
  vm_checkin_idScan_aila_learnMore: 'Weitere Informationen',
  vm_checkin_idScan_aila_scan_button: 'ID scannen',
  vm_checkin_idScan_back_picture_header_aila:
    'Legen Sie Ihren Ausweis in den Kartenträger mit der Rückseite zur Kamera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Positionieren Sie Ihren Ausweis vollständig innerhalb des Rahmens.',
  vm_checkin_idScan_back_picture_take_button: 'Rückseite scannen',
  vm_checkin_idScan_cancel_message: 'Das Einchecken wird abgebrochen und Sie gelangen zurück zum Startbildschirm.',
  vm_checkin_idScan_cancel_title: 'Achtung',
  vm_checkin_idScan_disclaimer_start_button: 'Starten',
  vm_checkin_idScan_disclaimer_text:
    'Im Rahmen unserer Sicherheitsrichtlinien müssen wir Ihre Identität anhand Ihres Personalausweises überprüfen.\n\nZum Schutz Ihrer persönlichen Daten wird das Foto Ihres Ausweises nicht gespeichert. Bei Fragen wenden Sie sich bitte an das Empfangspersonal.',
  vm_checkin_idScan_editName_title: 'Bitte tragen Sie Ihren Vor- und Nachnamen ein',
  vm_checkin_idScan_front_picture_header_aila:
    'Legen Sie Ihren Ausweis in den Kartenträger mit der Vorderseite zur Kamera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Positionieren Sie Ihren Ausweis vollständig innerhalb des Rahmens.',
  vm_checkin_idScan_front_picture_take_button: 'Ausweis Vorderseite scannen',
  vm_checkin_idScan_match_check: 'Beide Fotos werden verglichen',
  vm_checkin_idScan_match_confirm_button: 'Bestätigen',
  vm_checkin_idScan_match_error_default_header: 'Hoppla! Ein Fehler ist aufgetreten.',
  vm_checkin_idScan_match_error_default_message:
    'Wenden Sie sich an das Empfangspersonal oder versuchen Sie es erneut.',
  vm_checkin_idScan_match_error_idExpired_header: 'Entschuldigung, Ihre ID scheint abgelaufen zu sein.',
  vm_checkin_idScan_match_error_idExpired_message:
    'Wenden Sie sich an das Empfangspersonal oder versuchen Sie es erneut.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Es wurde kein Foto auf Ihrem Ausweis erkannt.',
  vm_checkin_idScan_match_error_idNoFace_message:
    'Wenden Sie sich an das Empfangspersonal oder versuchen Sie es erneut.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Es konnte kein Gesicht auf dem Foto erkannt werden',
  vm_checkin_idScan_match_error_pictureNoFace_message:
    'Wenden Sie sich an das Empfangspersonal oder versuchen Sie es erneut.',
  vm_checkin_idScan_region_0: 'Vereinigte Staaten',
  vm_checkin_idScan_region_1: ' Kanada',
  vm_checkin_idScan_region_2: 'Südamerika',
  vm_checkin_idScan_region_3: ' Europa',
  vm_checkin_idScan_region_4: ' Australien',
  vm_checkin_idScan_region_5: ' Asien',
  vm_checkin_idScan_region_6: ' Allgemeine Dokumente',
  vm_checkin_idScan_region_7: ' Afrika',
  vm_checkin_idScan_region_header: 'Wo wurde Ihr Ausweis ausgestellt?',
  vm_checkin_instructions_agreeTerms_button: 'Zustimmen',
  vm_checkin_instructions_clearSignature_button: 'Löschen',
  vm_checkin_instructions_sendCopy_button: 'Schicken Sie mir eine Kopie per E-Mail',
  vm_checkin_instructions_sendCopyTo_button: '{0} (Change) wird eine Kopie zugesandt',
  vm_checkin_instructions_sign: 'Bitte unterschreiben Sie hier mit Ihrem Finger',
  vm_checkin_instructions_tooltip_content:
    'Stellen Sie ein, ob Ihre Besuchenden Ihre Vereinbarungen mit einem einfachen Tippen oder einer Unterschrift akzeptieren sollen. Sie können Bedingungen von der Art des eincheckenden Besuchs abhängig machen. Diese Funktion und viele weitere können Sie im Dashboard anpassen.',
  vm_checkin_instructions_tooltip_title: 'Unterzeichnet',
  vm_checkin_method_name: 'Hallo, wie ist Ihr Name?',
  vm_checkin_method_name_enterFullName: 'Bitte geben Sie Ihren vollständigen Namen ein.',
  vm_checkin_method_name_invitationQuestion: 'Haben Sie eine Einladung mit einem QR-Code erhalten?',
  vm_checkin_method_name_notRegistered_block: 'Nicht aufgeführt? Bitte melden Sie sich an der Rezeption.',

  vm_checkin_method_name_notRegistered_continue: 'Nicht aufgeführt? Registrieren Sie sich.',

  vm_checkin_method_tooltip_content:
    'Checken Sie als "Justin Diaz" ein um zu sehen, wie wiederkehrende oder vorangemeldete Besuchende erkannt werden. Oder tippen Sie einen Beispiel-Namen ein, um zu sehen wie unangemeldete Besuchende adressiert werden.',
  vm_checkin_method_tooltip_title: 'Gästeerfassung',
  vm_checkin_picture_auto_countDown: 'Foto in',
  vm_checkin_picture_auto_lookCamera: 'Bitte schauen Sie für das Foto direkt in die Kamera ',
  vm_checkin_picture_auto_pictureTaken: 'Fertig',
  vm_checkin_picture_auto_stayStill: 'Bitte nicht bewegen',
  vm_checkin_picture_take_button: 'Foto aufnehmen',
  vm_checkin_picture_title: 'Foto aufnehmen',
  vm_checkin_picture_tooltip_content:
    'Sie können den Kiosk auf Ihre Bedürfnisse zuschneiden und ganz leicht Funktionen hinzufügen oder entfernen sowie Fotos der Besuchenden aufnehmen oder Namensschilder/Ausweise drucken.',
  vm_checkin_picture_tooltip_title: 'Optionale Funktionen',
  vm_checkin_qrcode_no_checkin_allowed:
    'Einchecken nicht erlaubt. Bitte kontaktieren Sie die Rezeption (wenn vorhanden) oder Ihre/-n Gastgebende.',
  vm_checkin_returning_email: 'Hallo, wie lautet Ihre E-Mail Adresse?',
  vm_checkin_returning_email_notRegistered:
    'Leider konnten wir keinen eingetragenen Besuch finden, der mit Ihrer E-Mail Adresse verknüpft ist. Bitte fragen Sie beim Empfangspersonal nach (wenn vorhanden) oder versuchen Sie es erneut mit einer anderen E-Mail Adresse.',
  vm_checkin_saveInfo_email:
    'Meine Informationen dürfen für ein schnelleres Einchecken für künftige Besuche gespeichert werden',
  vm_checkin_saveInfo_email_placeholder: 'Geben Sie Ihre E-Mail Adresse an',
  vm_checkin_saveInfo_title: 'Tragen Sie Ihre E-Mail Adresse ein',
  vm_checkin_summary_agreementAlreadySigned: 'Die Vereinbarung wurde bereits unterzeichnet',
  vm_checkin_summary_checkin_button: 'Jetzt einchecken',
  vm_checkin_summary_countDown: 'Einchecken fertig in',
  vm_checkin_summary_editDetails_button: 'Details bearbeiten',
  vm_checkin_summary_groupStats: '{0} von {1} Person(en) sind bereits dort',
  vm_checkin_summary_meetingTime: 'Treffen um {0}',
  vm_checkin_summary_reviewDetails_button: 'Details meines Besuchs überprüfen',
  vm_checkin_summary_sendPass_button: 'Ich möchte einen QR-Code Pass für künftige Besuche',
  vm_checkin_summary_sendPassTo_button: 'Eine permanenter Pass wird an {0} gesendet. (ändern)',
  vm_checkin_summary_takeNewPicture_button: 'Nehmen Sie ein neues Foto auf',
  vm_checkin_summary_title: 'Ihr Besuch bei {{Company_Name}}',

  vm_checkin_summary_visiting: 'besucht {0}',
  vm_checkin_video_duration: 'Dauer',
  vm_checkin_video_subtitle: 'Sehen Sie sich das ganze Video an, um mit dem Einchecken fortzufahren.',
  vm_checkin_welcome_firstTime: 'Herzlich Willkommen {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Ihr letzter Besuch war am {0}',
  vm_checkin_welcome_lastVisit_today: 'Ihr letzter Besuch war heute',
  vm_checkin_welcome_lastVisit_yesterday: 'Ihr letzter Besuch war gestern',
  vm_checkin_welcome_returning: 'Willkommen zurück {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Auf Wiedersehen {{Visitor_FirstName}} {{Visitor_LastName}}!',

  vm_checkout_confirmation_message: 'Sie wurden ausgecheckt. Wir hoffen, dass Sie einen angenehmen Aufenthalt hatten.',

  vm_checkout_confirmation_title: 'Vielen Dank für Ihren Besuch!',
  vm_checkout_method_name: 'Bitte geben Sie Ihren Namen ein um auszuchecken',
  vm_checkout_method_name_notFound: 'Nicht gefunden',
  vm_checkout_method_title: 'Auschecken',
  vm_identification_id_button: 'Scannen Sie Ihre ID',
  vm_identification_qrCode_button: 'Scannen Sie Ihren QR-Code',
  vm_infopack_confirmation: 'Danke, wir haben eine E-Mail an {0} geschickt.',
  vm_infopack_email: 'Geben Sie Ihre E-Mail-Adresse ein, damit wir Ihnen Informationen über Proxyclick senden können.',
  vm_infopack_likeCheckIn: 'Diese Art des Eincheckens hat Ihnen gefallen? Klicken Sie hier für weitere Informationen.',
  vm_infopack_likeProcess: 'Dieser Ablauf hat Ihnen gefallen? Klicken Sie hier für weitere Informationen.',
  vm_infopack_send_button: 'Informationen schicken',
  vm_multiTenant_title: 'Willkommen, welches Unternehmen besuchen Sie?',
  vm_product_footer_learnMore: 'Weitere Informationen',
  vm_product_footer_noPartner: 'Sie verwenden Proxyclick Welcome',
  vm_product_footer_partner: 'Sie verwenden Proxyclick mit freundlicher Unterstützung von {0}',
  vm_qrCode_help: 'Halten Sie Ihren Code 10-15 cm von der Kamera entfernt',
  vm_qrCode_not_recognized: 'Code nicht erkannt',
  vm_qrCode_title: 'Scannen Sie Ihren QR-Code',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>ANWEISUNGEN FÜR BESUCHENDE UND GEHEIMHALTUNGSVEREINBARUNG</h1><p>Herzlich willkommen! Wir freuen uns, Sie als Besuchnde bei {{Company_Name}} in unseren Räumlichkeiten begrüßen zu dürfen.</p><h2>Gesundheits- und Sicherheitsanweisungen</h2><p>Ihre persönliche Sicherheit während des Besuchs ist uns ein wichtiges Anliegen. Wir bitten Sie deshalb, die folgenden Anweisungen zu beachten:</p><ul><li><b>Der Zutritt zum Firmengelände</b> ist nur in Begleitung eines/-r Mitarbeitenden von {{Company_Name}} erlaubt</li><li>Der Besuchende<b>Ausweis</b> muss ständig getragen und beim Verlassen an der Rezeption abgegeben werden</li><li>Im<b>Notfall</b>, müssen alle Besuchende die Räumlichkeiten und das Firmengelände durch den nächsten sicheren Ausgang verlassen und sich an einem festgelegten Sammelpunkt einfinden. </li><li>Es ist für Besuchende verboten, <b></b> Bilder (Fotos und Videos) in den Firmenräumlichkeiten und auf dem Firmengelände aufzunehmen.</li><li><b>Das Rauchen in den Gebäuden</b> ist streng untersagt</li></ul><h2>Geheimhaltungsvereinbarung</h2><p>Während Ihres Aufenthalts in den Räumlichkeiten und auf dem Gelände von {{Company_Name}} werden Ihnen möglicherweise geschützte oder vertrauliche Informationen bekannt oder preisgegeben (einschließlich und ohne Einschränkung Informationen über Technologien, Prozesse, Anlagen, Zeichnungen und technische Daten), die der Öffentlichkeit im Allgemeinen nicht bekannt sind (nachstehend gemeinsam als&#34;Vertrauliche Informationen&#34; bezeichnet).</p><p>Unter Berücksichtigung Ihrer Besuchserlaubnis für die Räumlichkeiten von {{Company_Name}} und der üblichen Gepflogenheiten stimmen Sie zu;</p><p>(a) dass Sie vertrauliche Informationen, die Ihnen während des Besuchs und folgenden Besuchen bekannt werden, weder offenlegen noch anderen anderweitig zugänglich machen,</p><p>(b) dass Sie diese Informationen weder verwenden und weiterentwickeln noch andere dabei unterstützen und</p><p>(c) dass Sie keine Kamera- oder Videotechnik verwenden, um vertrauliche Informationen weiterzugeben.</p><p>Mit der Anmeldung in unseren Räumlichkeiten erklären Sie, dass Sie die Gesundheits- und Sichhereitsanweisungen anerkennen und verstehen.</p>',
  vm_signup_defaultInstruction_name: 'Standarddokument das von allen Besuchenden unterschrieben werden soll',
  vm_signup_defaultInstruction_title: 'Bitte unterschreiben Sie',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    'Sie erfüllen leider nicht die nötigen Impfvorschriften für den Zutritt',
  vm_vaccine_certification_accessDenied_title: 'Zutritt verweigert',
  vm_vaccine_certification_declare_question_title:
    'Willkommen, bitte geben Sie an, ob Sie eine gültige COVID-Impfbescheinigung oder einen COVID-Test mit negativem Ergebnis haben.',
  vm_vaccine_certification_intro_question_title: 'Willkommen, verfügen Sie über eine EU COVID-Impfbescheinigung?',
  vm_vaccine_certification_scanner_donthaveaqrcode: 'Ich habe keinen QR-code',
  vm_vaccine_certification_scanner_subtitle:
    'Stellen Sie sicher, dass Ihr QR-Code vergrößert ist und die Helligkeit Ihres Mobiltelefons auf maximum steht.',
  vm_vaccine_certification_scanner_title: 'Bitte halten Sie den QR-Code Ihres EU COVID-Zertifikats in die Kamera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'Einchecken',
  vm_welcome_checkout_button: 'Auschecken',
  vm_welcome_delivery_button: 'Lieferung',
  vm_welcome_hello_line1: 'Willkommen',
  vm_welcome_hello_line2: 'bei {{Company_Name}}',
  vm_welcome_qrCode_checkedIn: 'Willkommen! Bitte nicht vergessen später auszuchecken.',
  vm_welcome_qrCode_checkedOut: 'Auf Wiedersehen, {0}! ',
  vm_welcome_qrCode_notRecognized: 'Der QR Code wurde leider nicht erkannt. Bitte versuchen Sie es erneut.',
  vm_welcome_qrCode_scan:
    'Vorangemeldete Besuchende: Bitte halten Sie Ihren QR Code zum Ein-und Auschecken vor die Kamera',
  vm_welcome_qrCode_show: 'Mitarbeitende: Scannen Sie diesen QR-Code mit Proovr, um ein- oder auszuchecken.',
  vm_welcome_qrCode_wrongCompany: 'Ihr QR-Code ist für diesen Standort ungültig.',
  vm_welcome_returning_button: 'Schon mal hier gewesen?',
  vm_welcome_title: 'Willkommen bei {{Company_Name}}',
  vm_welcome_tooltip_content:
    'Um Ihren Kiosk zu personalisieren, loggen Sie sich einfach ins Dashboard ein. Wir habe Ihnen gerade eine E-Mail mit Anweisungen gesendet. Im Dashboard können Sie Ihr Logo und Ihr Hintergrundbild hochladen sowie eine Farbe auswählen, sodass Ihr Kiosk Ihre Markenidentität widerspiegelt.',
  vm_welcome_tooltip_title: 'Machen Sie es sich zu eigen',
  vm_welcome_touchless_employee_qrCode_show:
    'Mitarbeitende: Scannen Sie diesen QR-Code mit Proovr, um als Mitarbeitende einzuchecken',
  vm_welcome_touchless_qrCode_show:
    'Nicht vorangemeldete Besuchende: Scannen Sie diesen QR-Code für ein kontaktfreies Einchecken',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scannen Sie diesen QR-Code mit Proovr (Mitarbeitende) oder Ihrem Handy (unangemeldete Besuchende), um einzuchecken',
  vm_welcome_touchless_unexpected_qrCode_show:
    'Kontakfreies Einchecken: Scannen Sie diesen QR-Code mit Ihrem Handy, um als unangemeldete/-r Besuchende einzuchecken',
  common_or: 'oder',
};
